import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _PropTypes from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';
import { neutralColors, alertColors } from '../../styles/colors/colors.js';
import { spacing5x } from '../../styles/spacing.js';
import { fileSize } from '../../utils/util.js';
import { Box } from '../Box/Box.js';
import { IconStatusCheck } from '../Icons/IconStatusCheck.js';
import { IconStatusClose } from '../Icons/IconStatusClose.js';
import { IconStatusUrgent } from '../Icons/IconStatusUrgent.js';
import { LinkButton } from '../LinkButton/LinkButton.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

var CardInfo = styled.div.withConfig({
  displayName: "FileCard__CardInfo",
  componentId: "p8su6j-0"
})(["&&{text-align:left;width:calc(100% - ", ");}&& span{font-weight:600;display:block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}"], spacing5x);
var ProgressBar = styled.div.withConfig({
  displayName: "FileCard__ProgressBar",
  componentId: "p8su6j-1"
})(["&&{position:absolute;bottom:0;left:0;width:100%;height:5px;background-color:", ";", ";}"], neutralColors.silver, function (props) {
  return props.sizeUploaded && props.size && "span {\n         position: absolute;\n         top: 0;\n         bottom: 0;\n         left: 0;\n         width: ".concat(props.sizeUploaded > 0 ? props.sizeUploaded / props.size * 100 : 0, "%;\n         background: ").concat(alertColors.success, ";\n     }");
});
var FileCard = /*#__PURE__*/React.forwardRef(function FileCard2(props, ref) {
  var index = props.index,
      name = props.name,
      error = props.error,
      _props$sizeUploaded = props.sizeUploaded,
      sizeUploaded = _props$sizeUploaded === void 0 ? 0 : _props$sizeUploaded,
      success = props.success,
      size = props.size,
      onRemove = props.onRemove;
  return /*#__PURE__*/jsxs(Box, {
    style: _objectSpread({
      height: "64px",
      display: "flex",
      position: "relative"
    }, error ? {
      borderColor: alertColors.error
    } : {}),
    borderRadius: 1,
    elevationHover: 1,
    padding: 3,
    ref: ref,
    children: [/*#__PURE__*/jsxs(CardInfo, {
      children: [/*#__PURE__*/jsx("span", {
        children: name
      }), size && fileSize(size, 2)]
    }), /*#__PURE__*/jsx("div", {
      children: onRemove && size && sizeUploaded < size ? /*#__PURE__*/jsx(LinkButton, {
        label: "Remove file",
        hideLabel: true,
        startAdornment: IconStatusClose,
        onClick: function onClick() {
          return onRemove(index);
        }
      }) : /*#__PURE__*/jsxs(Fragment, {
        children: [success && /*#__PURE__*/jsx(IconStatusCheck, {
          color: alertColors.success,
          size: 16
        }), error && /*#__PURE__*/jsx(IconStatusUrgent, {
          color: alertColors.error,
          size: 16
        })]
      })
    }), !error && /*#__PURE__*/jsx(ProgressBar, {
      sizeUploaded: sizeUploaded,
      size: size,
      children: /*#__PURE__*/jsx("span", {
        role: "progressbar",
        "aria-valuenow": sizeUploaded,
        "aria-valuemin": 0,
        "aria-valuemax": size
      })
    })]
  });
});
FileCard.propTypes = {
  "error": _PropTypes.bool,
  "index": _PropTypes.number.isRequired,
  "name": _PropTypes.string,
  "onRemove": _PropTypes.func,
  "size": _PropTypes.number,
  "sizeUploaded": _PropTypes.number,
  "success": _PropTypes.bool
};
FileCard.displayName = "FileCard";

export { FileCard };
